import { graphql } from "../gql";

export const createClaimAuditGroupCommentMutationDoc = graphql(`
  mutation CreateClaimAuditGroupComment(
    $input: CreateClaimAuditGroupCommentInput!
  ) {
    createClaimAuditGroupComment(input: $input) {
      claimAuditGroupComment {
        id
        claimAuditGroupId
        authorId
        authorName
        body
        createdAt
      }
    }
  }
`);
